export class Import {
    id: number;
    organization: string;
    locationCodes: any;
    orgId: number;
    pped: string;
    payDate: string;
    records: number;
    user: string;
    submitted: Date;
    systems: string;
    contribution: any;
    remittanceReconciliationId: number;
    revenueControlTransmittalId: number;
    paymentStatus: number;
}
export class ImportResult {
    anyUnsubmittedImport: boolean;
    result: Import[];
    success: boolean;
}

export class ImportFileData {
    userInfo: any;
    scheduleEntryId: number;
}
